function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M56.5,49L56.5,49V1c0-0.6-0.4-1-1-1h-45c-0.6,0-1,0.4-1,1v14h2V2h43v46h-9c-0.6,0-1,0.4-1,1v9h-33V43h-2v16 c0,0.6,0.4,1,1,1h35c0.3,0,0.5-0.1,0.7-0.3l10-10c0.1-0.1,0.1-0.2,0.2-0.3v-0.1C56.5,49.2,56.5,49.1,56.5,49z M46.5,50h6.6 l-3.3,3.3l-3.3,3.3L46.5,50L46.5,50z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5,38h6h4v-2h-3V17c0-0.6-0.4-1-1-1h-6c-0.6,0-1,0.4-1,1v6h-5c-0.6,0-1,0.4-1,1v4h-5c-0.6,0-1,0.4-1,1v8 c0,0.6,0.4,1,1,1h6H16.5z M17.5,18h4v18h-4V24V18z M11.5,25h4v11h-4v-7V25z M5.5,30h4v6h-4V30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.5,24V7c0-0.6-0.4-1-1-1h-21c-0.6,0-1,0.4-1,1v17c0,0.6,0.4,1,1,1h21C50.1,25,50.5,24.6,50.5,24z M48.5,12h-12V8h12V12 z M34.5,8v4h-5c0-1.6,0-4,0-4H34.5z M29.5,14h5v9h-5C29.5,23,29.5,18.3,29.5,14z M36.5,23v-9h12v9H36.5z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 28.5,
  y: 28,
  width: 21,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 28.5,
  y: 33,
  width: 21,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 28.5,
  y: 38,
  width: 21,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 6,
  width: 6,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 11,
  width: 9,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 43,
  width: 7,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 24.5,
  y: 43,
  width: 7,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 34.5,
  y: 43,
  width: 7,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 48,
  width: 7,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 24.5,
  y: 48,
  width: 7,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 34.5,
  y: 48,
  width: 7,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 53,
  width: 7,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 24.5,
  y: 53,
  width: 7,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 34.5,
  y: 53,
  width: 7,
  height: 2
})));

const SvgOperationReport = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOperationReport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/operation-report.acc40afe.svg";
export { ForwardRef as ReactComponent };